import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const classicProjectSettingsIssueLayoutRoute: InvariantRoute = {
	name: 'project-settings-classic-issue-layout',
	path: '/plugins/servlet/project-config/:projectKey/issuelayout',
	query: ['screenId'],
	exact: true,
};
